
import img0 from './OnData_Default_Roles.png';
import img1 from './App_Role_Configuration.png';
import img2 from './Data_Access_Role_Configuration.png';
  
const content = `# Configuring Roles in Microsoft Entra ID

OnData supports the integration with Identity and Access Management (IAM) systems for user authentication and authorization. Both the OnData application roles and the 
data access roles can be configured in your IAM system, so that you can use your IAM system to control both user's access to the OnData application and user's access to 
your sensitive data. For details regarding the OnData application roles, please refer to [**OnData Application Roles**](reference_doc#how-to_guides/portal_configuration/ondata_application_roles). For details on how 
to configure data access roles, please refer to [**Data Access Roles**](reference_doc#how-to_guides/portal_configuration/data_access_roles). The purpose of this document is to detail the process of configuring 
user's application roles and data access roles using Microsoft Entra ID (formerly Azure Active Directory) as an example. The process to configure such roles within 
other types of IAM systems can be similar.  

## Prerequisite
a. An Entra ID user account with at least one of the following roles: Global Administrator, Cloud Application Administrator, or Application Administrator  
b. An OnData account with the System Administrator role  
c. The OnData Portal has been integrated with your Microsoft Entra ID for Single Sign-On (SSO) purpose. For details regarding Entra ID integration, please refer to 
[**Microsoft Entra ID Integration**](reference_doc#how-to_guides/portal_configuration/microsoft_entra_id_integration).  

## Configure App Roles for OnData Application
a. Go to Azure Portal, and select "App registrations"  
b. From the list applications, select the "OnData Portal" application  
c. Select "App roles" from the left menu  
d. For each application role configured at the OnData Portal, including the built-in roles and custom roles, if such role is needed for your organization, follow the 
steps below to add that role to the list:
   * Click on "Create app role"  
   * Enter a "Display name", select the "Users/Groups" option under the "Allowed member types", and enter the role value that is the same as the role value configured 
   at the OnData Portal. Below is the list of default roles configured at the OnData Portal:  
  
![OnData Default Roles](${ img0 })  
       
   * Enter a description and select the "Apply" button to create the application role  
  
![App Role Configuration](${ img1 })  
    
## Configure Data Access Roles
a. Go to Azure Portal, and select "App registrations"  
b. From the list applications, select the "OnData Portal" application  
c. Select "App roles" from the left menu  
d. For each data access role configured at the OnData Portal, if it is needed for your organization, follow the steps below to add that data access role to the list:
   * Click on "Create app role"  
   * Enter a "Display name" with a prefix of "DataAccessRole_", select the "Users/Groups" option under the "Allowed member types", and enter the role value 
   that is the same as the role value configured at the OnData Portal, except that it is prefixed with "DataAccessRole_". For example, if the data access role at the 
   OnData Portal has a value of "DataAdmin", the value to be used here is "DataAccessRole_DataAdmin"  
   * Enter a description and select the "Apply" button to create the data access role  
  
![Data Access Role Configuration](${ img2 })  
  
## Assign OnData Roles and Data Access Roles to Users and User Groups
Once the OnData application roles and the data access roles are configured through the App registration process in Entra ID, those roles can be assigned to your users 
and user groups. Below are the steps:  
a. Go to Azure Portal, and select "Enterprise applications"  
b. From the list applications, select the "OnData Portal" application  
c. On the “Overview” page, select “Assign users and groups” under the tile named “1.  Assign users and groups”  
d. Click on "Add user/group", and select one or more users or user groups from Entra ID  
e. Select an OnData application role or a data access role  
f. Click on the "Assign" button to complete the assignment  
g. Repeat the process above to assign various roles to various groups of users  
  
A user can be assigned one or more application roles and data access roles. When multiple roles are assigned, the permission of that user will be combined list of 
permissions from all assigned roles.  
  
  `
  
export default content;
